import { ResourceMenuActions, Stack, Typography } from '@all-manager/design-system-v2';
import ConfirmModal from "../../../../components/modals/ConfirmModal";
import type { SubTopicDatabase } from "../../../../types";
import DeleteSubTopicModal from "../DeleteSubTopicModal/DeleteSubTopicModal";
import MergeSubTopicModal from "../MergeSubTopicModal/MergeSubTopicModal";
import UpdateSubTopicModal from "../UpdateSubTopicModal/UpdateSubTopicModal";
import { type SubTopicActionsProps, useSubTopicActions } from "./useSubTopicActions";

type Props = SubTopicActionsProps;

export default function SubTopicActions(props: Props) {
  const hook = useSubTopicActions(props);

  return (
    <>
      <ResourceMenuActions
        size={props.size ?? 'small'}
        actions={hook.actions}
        ariaLabel={`Actions pour le sujet ${props.subTopic.name}`}
        tooltip="Options du sujet"
      />

      {hook.activeModal === 'update' && (
        <UpdateSubTopicModal
          subTopic={props.subTopic}
          onClose={hook.handleCloseModal}
        />
      )}

      {hook.activeModal === 'close' && (
        <ConfirmModal
          title="Clôturer le sujet"
          onClose={hook.handleCloseModal}
          onConfirm={hook.handleConfirmClose}
          color="primary"
        >
          Êtes-vous sûr de vouloir clôturer le sujet "{props.subTopic.name}" ?
        </ConfirmModal>
      )}

      {hook.activeModal === 'reopen' && (
        <ConfirmModal
          title="Réouvrir le sujet"
          onClose={hook.handleCloseModal}
          onConfirm={hook.handleConfirmReopen}
          color="primary"
        >
          Êtes-vous sûr de vouloir réouvrir le sujet "{props.subTopic.name}" ?
        </ConfirmModal>
      )}

      {hook.activeModal === 'archive' && (
        <ConfirmModal
          title="Archiver le sujet"
          onClose={hook.handleCloseModal}
          onConfirm={hook.handleConfirmArchive}
          color="primary"
        >
          <Stack spacing={1}>
            <Typography>
              Êtes-vous sûr de vouloir archiver le sujet "{props.subTopic.name}" ?
            </Typography>
            <Typography variant="body2">
              Il pourra être désarchivé à tout moment.
            </Typography>
          </Stack>
        </ConfirmModal>
      )}

      {hook.activeModal === 'delete' && (
        <DeleteSubTopicModal
          subTopic={props.subTopic as SubTopicDatabase}
          onClose={hook.handleCloseModal}
        />
      )}

      {hook.activeModal === 'merge' && (
        <MergeSubTopicModal
          subTopic={props.subTopic}
          onClose={hook.handleCloseModal}
        />
      )}
    </>
  );
}

export type { SubTopicActionsProps };
